import { render } from "./list-country.vue?vue&type=template&id=65bd48d5&lang=html"
import script from "./list-country.vue?vue&type=script&lang=js"
export * from "./list-country.vue?vue&type=script&lang=js"

import "./list-country.vue?vue&type=style&index=0&id=65bd48d5&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__